/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientDispenseRecordImageRequestTypename = "PatientDispenseRecordImageRequest" as const;

/**
 *
 * @export
 * @interface PatientDispenseRecordImageRequest
 */
export interface PatientDispenseRecordImageRequest {
  /**
   *
   * @type {string}
   * @memberof PatientDispenseRecordImageRequest
   */
  raw: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientDispenseRecordImageRequest
   */
  readonly __typename?: string;
}

export function PatientDispenseRecordImageRequestFromJSON(json: any): PatientDispenseRecordImageRequest {
  return PatientDispenseRecordImageRequestFromJSONTyped(json, false);
}

export function PatientDispenseRecordImageRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatientDispenseRecordImageRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientDispenseRecordImageRequestTypename,

    raw: json["raw"],
  };
}

export function PatientDispenseRecordImageRequestToJSON(object?: PatientDispenseRecordImageRequest | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    raw: value.raw,
  };
}
